export default "__VITE_ASSET__CpOk5FoC__"